import axios from '@axios'

const PREFIX = '/documentos-e-licencas'

export default {

  getDocumentoLicencas(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },
  getAllEmpresas() {
    return axios.get(`${PREFIX}/empresas`)
  },
  GetDocumentoLicencaById(id) {
    return axios.get(`${PREFIX}/${id}`)
  },
  createDocumentoLicenca(documentoLicenca) {
    return axios.post(`${PREFIX}/add`, documentoLicenca)
  },
  delete(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },
  update(id, documentoLicenca) {
    return axios.put(`${PREFIX}/${id}`, documentoLicenca)
  },
  updateObservacao(id, observacao) {
    return axios.put(`${PREFIX}/${id}/observacao`, observacao)
  },
  getDocumentoLicencaByEmpresaId(empresaId, ocultar) {
    return axios.get(`${PREFIX}/empresa/${empresaId}?ocultar=${ocultar}`)
  },
  addHistorico(id, tela) {
    return axios.post(`${PREFIX}/${id}/historico?tela=${tela}`)
  },
  getHistoricos(id) {
    return axios.get(`${PREFIX}/${id}/historico`)
  },
  getDocumentoLicencasDispensar(documentoLicencaId) {
    return axios.post(`${PREFIX}/dispensa`, documentoLicencaId)
  },
  getTiposDocumentoLicenca() {
    return axios.get(`${PREFIX}/tipos-documento-licenca`)
  },
  exportarRelatorio(filtros) {
    return axios.post(`${PREFIX}/relatorio`, filtros)
  },
}
